import axios from 'axios';
import isEqual from 'lodash.isequal';

export default class Form {
    constructor(form, index = null) {
        this.form = form;
        this.formdata = {};
        this.blockUnchanged = false;

        if (index !== null) {
            this.form.classList.add(`sendform_${index}`)
        }

        this.notificationArea = this.form.querySelector('.notify');

        return this;
    }

    /**
     * Disable sending of the same form twice
     *
     * @returns {Form}
     */
    onlyOnce()
    {
        this.blockUnchanged = true;

        return this;
    }

    /**
     * Reset notification area
     */
    resetNotifications()
    {
        this.notificationArea.classList.add('hidden');
        this.notificationArea.classList.remove('notify_success', 'notify_failure');
        this.notificationArea.innerText = '';
    }

    /**
     * Show success message
     *
     * @param {string} message
     */
    showSuccessMessage(message)
    {
        this.notificationArea.innerHTML = message;
        this.notificationArea.classList.add('notify_success');
        this.notificationArea.classList.remove('hidden');
    }

    /**
     * Show failure message
     *
     * @param {string} message
     */
    showFailureMessage(message)
    {
        this.notificationArea.innerHTML = message;
        this.notificationArea.classList.add('notify_failure');
        this.notificationArea.classList.remove('hidden');
    }

    /**
     * Disable and toggle submit button text after submitting the form
     */
    toggleSubmitButtonText()
    {
        let button= this.form.querySelector('button[type="submit"]');
        if (button && button.dataset.textSending) {
            let buttonText = button.innerHTML;
            button.innerHTML = button.dataset.textSending;
            button.disabled = true;

            setTimeout(() => {
                button.innerHTML = buttonText;
                button.disabled = false;
            }, 3000);
        }
    }

    /**
     * Check if data was changed
     *
     * @param {object} data
     * @returns {boolean}
     */
    dataWasChanged(data)
    {
        if (!this.blockUnchanged) {
            return true;
        }

        if (this.formdata.length === 0) {
            return true;
        }

        return !isEqual(data, this.formdata);
    }

    /**
     * Fetch all relevant data for the form.
     */
    data() {
        let data = {};

        this.form.querySelectorAll('input, textarea').forEach(function (input) {
            if (input.name !== '') {
                data[input.name] = input.value;
            }
        });

        return data;
    }

    /**
     * Reset the form fields.
     */
    reset() {
        this.resetNotifications();

        this.form.querySelectorAll('input, textarea').forEach(function (input) {
            if (input.name !== '') {
                input.classList.remove('has_error');

                let errorSpans = this.form.querySelectorAll('#error_' + input.name);
                errorSpans.forEach(function (errorSpan) {
                    if (errorSpan) {
                        errorSpan.innerHTML = '';
                        errorSpan.classList.add('hidden');
                    }
                });
            }
        }, this);
    }

    /**
     * Send a POST request to the given URL.
     * .
     * @param {string} url
     */
    post(url) {
        return this.submit('post', url);
    }

    /**
     * Submit the form.
     *
     * @param {string} requestType
     * @param {string} url
     */
    submit(requestType, url) {
        this.toggleSubmitButtonText();
        this.reset();

        return new Promise((resolve, reject) => {
            let data = this.data();

            if (this.blockUnchanged && !this.dataWasChanged(data)) {
                let button =  this.form.querySelector('button[type="submit"]');
                this.showFailureMessage(button.dataset.textUnique ? button.dataset.textUnique : 'This message has already been sent');

                return;
            }

            this.formdata = data;

            axios[requestType](url, data)
                .then(response => {
                    this.onSuccess(response.data);

                    resolve(response.data);
                })
                .catch(error => {
                    this.onFail(error.response.data, error.response.status);

                    reject(error);
                });
        });
    }

    /**
     * Handle a successful form submission.
     *
     * @param {object} data
     */
    onSuccess(data) {
        this.showSuccessMessage(data.message);
    }

    /**
     * Handle a failed form submission.
     *
     * @param {object} errors
     */
    onFail(errors, status) {
        if (status === 403) {
            this.showFailureMessage(errors.message);
        } else if (status === 422) {
            for (const error in errors.errors) {
                if (this.form.querySelector(`input[name="${error}"], textarea[name="${error}"]`)) {
                    this.form.querySelector(`input[name="${error}"], textarea[name="${error}"]`).classList.add('has_error')
                    this.form.querySelector(`#error_${error}`).classList.remove('hidden');
                    this.form.querySelector(`#error_${error}`).innerHTML = errors.errors[error].join('<br/>');
                }
            }
        } else {
            this.showFailureMessage(errors.message)
        }
    }
}
